import moment from 'moment'
import { EnumTipoDocumento } from '../../../../api'
import { DocumentModel } from '../../../../api/Argentia/endpoints/documents/model/document'
import { ConsumoRequestModel } from '../../../../api/Pioneer/endpoints/files/models/files'
import {
  DownloadCurrentFormData,
  historicalFilesCardDataTableModel
} from './historicalFilesCard.model'

export const mapDocumentModelToDataTable = (
  documents: DocumentModel[]
): historicalFilesCardDataTableModel[] => {
  return documents.map(document => ({
    ...document,
    canDownloadDocument: !NOT_DOWNLOADABLE_DOCUMENTS.includes(document.type)
  }))
}

const NOT_DOWNLOADABLE_DOCUMENTS: EnumTipoDocumento[] = [EnumTipoDocumento.Contractual]

export const mapDownloadCurrentFormDataToRequest = (
  formData: DownloadCurrentFormData
): ConsumoRequestModel => {
  return {
    tipoDocumento: formData.documentType,
    idPuntoSuministro: formData.supplyPointId,
    fechaInicio: moment(formData.startDate).format('YYYY-MM-DD'),
    fechaFin: moment(formData.endDate).format('YYYY-MM-DD'),
    idDocumento: formData.documentId
  }
}
